import service from '@/utils/request'; // CreateStationBaseInfo 创建油站基础信息
// @Tags Station
// @Summary 创建油站基础信息
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body bairunModel.StationModel true "创建油站基础信息"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /stationManage/stationBaseInfo/create [post]

export var createStationBaseInfo = function createStationBaseInfo(data) {
  return service({
    url: '/stationManage/stationBaseInfo/create',
    method: 'post',
    data: data
  });
}; // DeleteStationBaseInfo 删除油站信息
// @Tags Station
// @Summary 删除油站信息
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body bairunModel.StationModel true "删除油站信息"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"删除成功"}"
// @Router /stationManage/stationBaseInfo/delete [delete]

export var deleteStationBaseInfo = function deleteStationBaseInfo(data) {
  return service({
    url: '/stationManage/stationBaseInfo/delete',
    method: 'post',
    data: data
  });
}; // DeleteStationBaseInfoByIds 批量删除油站信息
// @Tags Station
// @Summary 批量删除油站信息
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body request.IdsReq true "批量删除油站信息"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"批量删除成功"}"
// @Router /stationManage/stationBaseInfo/deleteByIds [delete]

export var deleteStationBaseInfoByIds = function deleteStationBaseInfoByIds(data) {
  return service({
    url: '/stationManage/stationBaseInfo/deleteByIds',
    method: 'post',
    data: data
  });
}; // UpdateStationBaseInfo 更新油站基础信息
// @Tags Station
// @Summary 更新油站基础信息
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body bairunModel.stationModel true "更新油站基础信息"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"更新成功"}"
// @Router /stationManage/stationBaseInfo/update [put]

export var updateStationBaseInfo = function updateStationBaseInfo(data) {
  return service({
    url: '/stationManage/stationBaseInfo/update',
    method: 'put',
    data: data
  });
}; // FindStationBaseInfo 根据id查询油站基础信息
// @Tags Station
// @Summary 根据id查询油站基础信息
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body bairunModel.stationModel true "根据id查询油站基础信息"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"查询成功"}"
// @Router /stationManage/stationBaseInfo/find [get]

export var findStationBaseInfo = function findStationBaseInfo(params) {
  return service({
    url: '/stationManage/stationBaseInfo/find',
    method: 'get',
    params: params
  });
}; // GetStationBaseInfoList 分页获取油站列表信息，根据油站权限控制
// @Tags Station
// @Summary 分页获取油站列表信息
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body bairunRequest.StationBaseInfoSearch true "分页获取油站列表信息"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /stationManage/stationBaseInfo/getList [get]

export var getStationBaseInfoList = function getStationBaseInfoList(params) {
  return service({
    url: '/stationManage/stationBaseInfo/getList',
    method: 'get',
    params: params
  });
}; // getStationAllList 分页获取全部油站列表信息，没有权限控制
// @Tags Station
// @Summary 分页获取油站列表信息
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body bairunRequest.StationBaseInfoSearch true "分页获取油站列表信息"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /stationManage/stationBaseInfo/getAllList [get]

export var getStationAllList = function getStationAllList(params) {
  return service({
    url: '/stationManage/stationBaseInfo/getAllList',
    method: 'get',
    params: params
  });
}; // getStationAllList 分页获取集团列表信息
// @Tags Station
// @Summary 分页获取集团列表信息
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /stationManage/stationGroup/getList [get]

export var getStationGroupList = function getStationGroupList(params) {
  return service({
    url: '/stationManage/stationGroup/getList',
    method: 'get',
    params: params
  });
}; // createStationGroup 创建集团
// @Tags Station
// @Summary 创建集团
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body request.IdsReq true "创建集团"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /stationManage/stationGroup/create [post]

export var createStationGroup = function createStationGroup(data) {
  return service({
    url: '/stationManage/stationGroup/create',
    method: 'post',
    data: data
  });
}; // updateStationGroup 变更集团
// @Tags Station
// @Summary 变更集团
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body request.IdsReq true "变更集团"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /stationManage/stationGroup/update [post]

export var updateStationGroup = function updateStationGroup(data) {
  return service({
    url: '/stationManage/stationGroup/update',
    method: 'post',
    data: data
  });
}; // deleteStationGroup 删除集团
// @Tags Station
// @Summary 删除集团
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body request.IdsReq true "删除集团"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /stationManage/stationGroup/delete [post]

export var deleteStationGroup = function deleteStationGroup(data) {
  return service({
    url: '/stationManage/stationGroup/delete',
    method: 'post',
    data: data
  });
}; // getCommentTagList 分页获取评论标签
// @Tags Station
// @Summary 分页获取评论标签
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /stationManage/comment/tag/getList [get]

export var getCommentTagList = function getCommentTagList(params) {
  return service({
    url: '/stationManage/comment/tag/getList',
    method: 'get',
    params: params
  });
}; // createCommentTag 创建评论标签
// @Tags Station
// @Summary 创建评论标签
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body request.IdsReq true "创建评论标签"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /stationManage/comment/tag/create [post]

export var createCommentTag = function createCommentTag(data) {
  return service({
    url: '/stationManage/comment/tag/create',
    method: 'post',
    data: data
  });
}; // updateCommentTag 更新评论标签
// @Tags Station
// @Summary 更新评论标签
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body request.IdsReq true "更新评论标签"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /stationManage/comment/tag/create [post]

export var updateCommentTag = function updateCommentTag(data) {
  return service({
    url: '/stationManage/comment/tag/update',
    method: 'post',
    data: data
  });
}; // delCommentTag 删除评论标签
// @Tags Station
// @Summary 删除评论标签
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body request.IdsReq true "删除评论标签"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /stationManage/comment/tag/delete [post]

export var delCommentTag = function delCommentTag(data) {
  return service({
    url: '/stationManage/comment/tag/delete',
    method: 'post',
    data: data
  });
}; // getStationCommentTagList 分页获取油站评论标签
// @Tags Station
// @Summary 分页获取油站评论标签
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /stationManage/comment/station/tag/getList [get]

export var getStationCommentTagList = function getStationCommentTagList(params) {
  return service({
    url: '/stationManage/comment/station/tag/getList',
    method: 'get',
    params: params
  });
}; // createStationCommentTag 创建油站评论标签
// @Tags Station
// @Summary 创建油站评论标签
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body request.IdsReq true "创建油站评论标签"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /stationManage/comment/station/tag/create [post]

export var createStationCommentTag = function createStationCommentTag(data) {
  return service({
    url: '/stationManage/comment/station/tag/create',
    method: 'post',
    data: data
  });
}; // updateStationCommentTag 更新油站评论标签
// @Tags Station
// @Summary 更新油站评论标签
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body request.IdsReq true "更新油站评论标签"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /stationManage/comment/station/tag/create [post]

export var updateStationCommentTag = function updateStationCommentTag(data) {
  return service({
    url: '/stationManage/comment/station/tag/update',
    method: 'post',
    data: data
  });
}; // delStationCommentTag 删除油站评论标签
// @Tags Station
// @Summary 删除油站评论标签
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body request.IdsReq true "删除油站评论标签"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /stationManage/comment/station/tag/delete [post]

export var delStationCommentTag = function delStationCommentTag(data) {
  return service({
    url: '/stationManage/comment/station/tag/delete',
    method: 'post',
    data: data
  });
}; // getUserCommentList 分页获取用户评论
// @Tags Station
// @Summary 分页获取用户评论
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /stationManage/comment/user/order/getList [get]

export var getUserCommentList = function getUserCommentList(params) {
  return service({
    url: '/stationManage/comment/user/order/getList',
    method: 'get',
    params: params
  });
}; // getUserCommentList 差评导出
// @Tags Station
// @Summary 差评导出
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /stationManage/comment/user/order/download [get]

export var exportBadCommonet = function exportBadCommonet(params) {
  return service({
    url: '/stationManage/comment/user/order/download',
    method: 'get',
    params: params
  });
}; // updateUserComment 更新用户评论
// @Tags Station
// @Summary 更新用户评论
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body request.IdsReq true "更新用户评论"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /stationManage/comment/user/order/update [post]

export var updateUserComment = function updateUserComment(data) {
  return service({
    url: '/stationManage/comment/user/order/update',
    method: 'post',
    data: data
  });
}; // getUserCommentAnalyse 评论分析统计
// @Tags Station
// @Summary 评论分析统计
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /stationManage/comment/user/order/analysis [get]

export var getUserCommentAnalyse = function getUserCommentAnalyse(params) {
  return service({
    url: '/stationManage/comment/user/order/analysis',
    method: 'get',
    params: params
  });
}; // getTagTypeList 评论标签类型
// @Tags Station
// @Summary 评论标签类型
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /stationManage/comment/tag/type/getList [get]

export var getTagTypeList = function getTagTypeList(params) {
  return service({
    url: '/stationManage/comment/tag/type/getList',
    method: 'get',
    params: params
  });
}; // getProvinceList 获取省份
// @Tags Station
// @Summary 获取省份
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /stationManage/district/getList [get]

export var getProvinceList = function getProvinceList(params) {
  return service({
    url: '/stationManage/district/getList',
    method: 'get',
    params: params
  });
};